import useGlobalState from '@stores/global.state';
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from 'styled-components';
import { useAuth, useAuthActions, useAuthUser, useAuthUserOrNull } from '@frontegg/react';
import { useCallback, useEffect, useState } from 'react';
import AuthService, { AuthProvider } from '@services/auth/auth.service';
import ConfigService from '@services/config/config.service';
import { useDraftVersionId } from '@stores/data.store';
import { FullPageLoader } from '@components/loaders/FullPageLoader.component';
import { showKeyboardShortcuts } from '@services/alert/alert.service';
import { useHotkeys } from 'react-hotkeys-hook';
import { addParamToCurrentUrl, copyTextToClipboard } from '../utils/browser';
import toast from '@services/toast.service';


const HelpButton = styled.button`
    

position: fixed;
z-index: 5000;
background-color: var(--pliable-yellow);
border: none;
font-family: "Poppins";
font-weight: bold;
font-size: 20px;
color: white;
padding: 1rem 2rem;
border-radius: 15px;
bottom: 2rem;
right: 2rem;
box-shadow: 1px 1px 5px 0px #555;

&:hover {
    background-color: var(--ct-primary);
}

    
`

const ToggleLibraryButton = styled.button`

`

const AuthenticatedRootPage = () => {
    const fronteggAuthState = useAuth();
    // we want this to load high up in the app to force cached branch to load
    const {data: draftVersionId} = useDraftVersionId();

    useHotkeys('meta+/', () => {
        console.log('showing keyboard shortcuts');
        showKeyboardShortcuts();
        
    }, []);

    useHotkeys('ctrl+s', () => {
        if(!!fronteggAuthState?.user?.tenantId){
            const shareUrl = addParamToCurrentUrl('inbound_tenant_id', fronteggAuthState?.user?.tenantId);
            copyTextToClipboard(shareUrl);
            toast('success', 'Success', 'Link copied to clipboard.');
        }
        
    }, [fronteggAuthState?.user?.tenantId]);

    const dataLibraryVisible = useGlobalState((state: any) => !state.libraryCollapsed)

    const dataLibraryEnabled = useGlobalState((state: any) => state.libraryEnabled);
    const setLibraryEnabled = useGlobalState((state: any) => state.setLibraryEnabled);
    const location = useLocation();

    let className = 'd-flex flex-nowrap';

    if (dataLibraryEnabled && dataLibraryVisible) {
        className = className + ' data-library';
    }

    useEffect(() => {
        // Default to true and let individual pages hide it
        setLibraryEnabled(true);
    }, [location]);

    return (
        <AuthProvider>
            <Outlet/>
        </AuthProvider>
    );
}

export default AuthenticatedRootPage;